module.exports = __webpack_public_path__ + "img/mouth-1-2.70b3c808.svg";